
export abstract class BIM360IssueComment {
    public id: string = '';
    static type: string = 'comments';
    public issue_id: string = '';
    public body: string = '';
    public created_by: string = '';
    public created_at: string = '';
    public updated_at: string = '';
}
